import { APIClient } from "./axiosClient";

const api = new APIClient();

const path = "/bars";
const barListApi = {
  bars(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  getBarDetail(id: string | number, params: any = {}): Promise<any> {
    const url = `${path}/${id}`;
    return api.get(url, params);
  },

  createBar(params: any) {
    return api.post(path, params);
  },

  updateBar(id: any, params: any) {
    return api.put(`${path}/${id}`, params);
  },

  deleteBar(id: any) {
    return api.delete(`${path}/${id}`);
  },

  getBarsType(params: any): Promise<any> {
    const url = `${path}/types`;
    return api.get(url, params);
  },

  verifyBusinessNumber(params: any) {
    return api.post(`${path}/verify-business-number`, params);
  },
};

export default barListApi;
